import { createAsyncThunk } from '@reduxjs/toolkit';

// Async thunk to delete a task
export const deleteTaskThunk = createAsyncThunk(
  'projectDraft/deleteTask',
  async ({ phaseId, taskId }, { getState, dispatch, rejectWithValue }) => {
    try {
      const state = getState().projectDraft;
      const firestoreId = state.firestoreDraftId;

      if (firestoreId) {
        const { deleteTaskFromFirebase } = await import('../../../pages/home/Projects/api/projectOperations');
        await deleteTaskFromFirebase(firestoreId, phaseId, taskId);
      }

      // Update local state
      dispatch({ type: 'projectDraft/deleteTaskLocal', payload: { phaseId, taskId } });

      return { phaseId, taskId };
    } catch (error) {
      console.error('Failed to delete task:', error);
      return rejectWithValue(error.message);
    }
  }
);
